module.exports = __webpack_public_path__ + "img/ANGEL SHADES RED.cf72de6.svg";